var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96667 14.6L8.44444 13.15L6.175 11L8.44444 8.85L6.96667 7.4L3.16667 11L6.96667 14.6ZM12.0333 14.6L15.8333 11L12.0333 7.4L10.5556 8.85L12.825 11L10.5556 13.15L12.0333 14.6ZM2.11111 20C1.53056 20 1.03339 19.8043 0.619611 19.413C0.206537 19.021 0 18.55 0 18V4C0 3.45 0.206537 2.979 0.619611 2.587C1.03339 2.19567 1.53056 2 2.11111 2H6.54444C6.77315 1.4 7.15596 0.916667 7.69289 0.55C8.22911 0.183333 8.83148 0 9.5 0C10.1685 0 10.7712 0.183333 11.3082 0.55C11.8444 0.916667 12.2269 1.4 12.4556 2H16.8889C17.4694 2 17.9666 2.19567 18.3804 2.587C18.7935 2.979 19 3.45 19 4V18C19 18.55 18.7935 19.021 18.3804 19.413C17.9666 19.8043 17.4694 20 16.8889 20H2.11111ZM9.5 3.25C9.7287 3.25 9.918 3.179 10.0679 3.037C10.2171 2.89567 10.2917 2.71667 10.2917 2.5C10.2917 2.28333 10.2171 2.104 10.0679 1.962C9.918 1.82067 9.7287 1.75 9.5 1.75C9.2713 1.75 9.08235 1.82067 8.93317 1.962C8.78328 2.104 8.70833 2.28333 8.70833 2.5C8.70833 2.71667 8.78328 2.89567 8.93317 3.037C9.08235 3.179 9.2713 3.25 9.5 3.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationIcon);
export default __webpack_public_path__ + "static/media/integrationIcon.afd5f6da095eee2428c7bd037ee71247.svg";
export { ForwardRef as ReactComponent };